module.exports = __webpack_public_path__ + "origin-order2.9a42d9c722e20ff6a69a.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/assets/vcg/img/origin-order2.svg
// module id = ../../../../../src/assets/vcg/img/origin-order2.svg
// module chunks = styles